module.exports = __webpack_public_path__ + "img/Recycle.ba170feb.png";